import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdminService } from '../admin.service';
import { confirm } from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';

@Component({
  selector: 'app-locations-list',
  standalone: false,
  templateUrl: './locations-list.component.html',
  styleUrls: ['./locations-list.component.css']
})
export class LocationsListComponent implements OnInit {
  locations: any[] = [];

  constructor(private admin: AdminService, private router: Router) { }

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.admin.getLocations().subscribe(
      l => this.locations = this.unwrap(l),
      () => notify('Unable to load locations', 'error', 2500)
    );
  }

  private unwrap(res: any): any[] {
    return Array.isArray(res) ? res : (res?.data ?? []);
  }

  onToolbarPreparing(e: any): void {
    e.toolbarOptions.items.unshift({
      location: 'after',
      widget: 'dxButton',
      options: { icon: 'plus', text: 'Add Location', type: 'default', onClick: () => this.router.navigate(['/admin/locations/new']) }
    });
  }

  onEditClick = (e: any): void => { this.router.navigate(['/admin/locations', e.row.data.id]); };

  onDeleteClick = (e: any): void => {
    const loc = e.row.data;
    confirm(`Delete location "${loc.name}"? This cannot be undone.`, 'Confirm delete').then(ok => {
      if (!ok) { return; }
      this.admin.deleteLocation(loc.id).subscribe(() => {
        notify('Location deleted', 'success', 2000);
        this.load();
      }, err => notify(err?.error?.message || 'Unable to delete location', 'error', 2500));
    });
  };
}
